/**
 * Formats a phone number to (XXX) XXX-XXXX format
 * @param {string} value - The phone number string (can be formatted or unformatted)
 * @returns {string} - Formatted phone number
 */
export const formatPhoneNumber = (value) => {
  if (!value) return '';

  // Remove all non-digit characters
  const phoneNumber = value.replace(/\D/g, '');

  // Format based on length
  const phoneNumberLength = phoneNumber.length;

  if (phoneNumberLength < 4) {
    return phoneNumber;
  }

  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }

  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

/**
 * Removes formatting from a phone number to get just digits
 * @param {string} value - The formatted phone number
 * @returns {string} - Just the digits
 */
export const unformatPhoneNumber = (value) => {
  if (!value) return '';
  return value.replace(/\D/g, '');
};

/**
 * Handles phone input change with automatic formatting
 * @param {string} value - The input value
 * @returns {string} - Formatted value
 */
export const handlePhoneInput = (value) => {
  // Remove all non-digit characters
  const phoneNumber = value.replace(/\D/g, '');

  // Limit to 10 digits
  const limitedPhoneNumber = phoneNumber.slice(0, 10);

  // Format the number
  return formatPhoneNumber(limitedPhoneNumber);
};
